
import {Form} from '$src/common/forms'
import {React} from '$src/handy'
import * as css from './Left.css'
import CheckBoxGroupInput from '$src/common/CheckBoxGroupInput'
import MultiSelectInput from '$src/common/MultiSelectInput'
import TextInput from '$src/common/TextInput'
import RangeInput from '$src/common/RangeInput'
import RadioGroupInput from '$src/common/RadioGroupInput'
import DateRangeInput from '$src/common/DateRangeInput'
import {municipalities, postalCodes} from '$src/hardCodedData'

interface Props {
    onSubmit: ()=>void;
    valuesMst: any;
    frozen: boolean;
    premiseData: any;
}

const PremiseFilters = (props: Props)=>{
    const propertyOptions = [
        {value: 'rowHouse', label: 'Row House'},
        {value: 'detachedhouse', label: 'Detached House'},
        {value: 'apartment', label: 'Apartment'},
    ];

    const elevatorOptions = [
        {value: '', label: "Doesn't matter"},
        {value: true, label: 'Yes'},
        {value: false, label: 'No'},
    ];

    const plotOptions = [
        {value: '', label: "Doesn't matter"},
        {value: true, label: 'Yes'},
        {value: false, label: 'No'},
    ];

    const newlyBuiltOptions = [
        {value: '', label: "Doesn't matter"},
        {value: true, label: 'Yes'},
        {value: false, label: 'No'},
    ];

    const conditionOptions = [
        {value: 'unknown', label: 'Tuntematon'},
        {value: 'bad', label: 'Huono'},
        {value: 'moderate', label: 'Tyydyttävä'},
        {value: 'good', label: 'Hyvä'},
        {value: 'excellent', label: 'Erinomainen'},
    ];
        
    return (
        <Form
            onSubmit={props.onSubmit}
            valuesMst={props.valuesMst}
            disabled={props.frozen}
        >
            <CheckBoxGroupInput.Field
                label="Property Type"
                name="propertyType"
                options={propertyOptions}
            />
            <MultiSelectInput.Field
                label="Municipality"
                name="municipality"
                options={municipalities}
            />
            <MultiSelectInput.Field
                label="Postal Codes"
                name="postalCode"
                options={postalCodes}
            />
            <TextInput.Field
                label="Street Address"
                style="small"
                css={{input: css.textInput}}
                name="streetAddress"
                placeholder="Any street address"
            />
            <RangeInput.Field label="Living Area" name="livingArea" />
            <RangeInput.Field
                label="Year of Construction"
                name="yearOfConstruction"
            />
            <RangeInput.Field label="Number of Rooms" name="numberOfRooms" />
            <RadioGroupInput.Field
                label="Newly built house?"
                name="newlyBuilt"
                options={newlyBuiltOptions}
            />
            <MultiSelectInput.Field
                label="Condition"
                name="condition"
                options={conditionOptions}
            />
            <DateRangeInput.Field
                name="dateOfSale"
                label="Date of Sale"
                tip="Write day and month with two digits,<br />e.g. 01/01/2020 instead of 1/1/2020"
            />
            <RadioGroupInput.Field
                label="Plot owned"
                name="plotOwned"
                options={plotOptions}
            />
            <RadioGroupInput.Field
                label="Elevator"
                name="hasElevator"
                options={elevatorOptions}
            />
        </Form>
    )
}
 
export default PremiseFilters;


// WEBPACK FOOTER //
// ./src/comparableSales/PremiseFilters.tsx